<template>
    <div>
        <el-button
                @click="downloadSpecialTimeTemplate"
                icon="el-icon-download"
                size="mini"
        >
            樣板下載
        </el-button>
        <el-button
                @click="exportSpecialTimeSettings"
                icon="el-icon-download"
                size="mini"
        >
            匯出
        </el-button>

        <el-button :loading="loading"
                   @click="refresh"
                   icon="el-icon-refresh-right"
                   size="mini">
            重新載入
        </el-button>
        <el-upload
                :action="action"
                :headers="uploadHeaders"
                :on-success="onUploadSuccess"
                :show-file-list="false"
                accept=".xlsx"
                name="import"
                style="margin-top: 5px;"
        >
            <el-button
                    icon="el-icon-upload2"
                    size="mini"
                    type="info"

            >
                匯入
            </el-button>
        </el-upload>
        <el-table
                :data="pagedData.map((p, idx) => ({idx : idx + 1, ...p}))"
                empty-text="目前無設定"
                height="620px"
        >
            <el-table-column
                    label="學年/學期"
            >
                <template #default="{row}">
                    {{`${row.schoolYear}/${semesterFormatted(row.semester)}`}}
                </template>
            </el-table-column>
            <el-table-column
                    label="上課日期"
                    prop="date"
            ></el-table-column>
            <el-table-column
                    label="節次標籤"
                    prop="tag"
            ></el-table-column>
            <el-table-column
                    label="節次起訖"
            >
                <template #default="{row}"
                >
                    {{`[${row.begin}-${row.end}]`}}
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                :page-size="pageSize"
                :current-page.sync="currentPage"
                :total="specialMappings.length"
                @current-change="page => pageChange(page, specialMappings)"
                background
                layout="total, prev, pager, next"
                style="margin-top: 10px;"
        ></el-pagination>
    </div>
</template>

<script>
    import {createNamespacedHelpers} from 'vuex';
    import pagingMixin from '../../pagingMixin';
    import uploadMixin from '../../uploadMixin';
    import {base, Semesters} from '../../constants';

    const {mapState, mapActions, mapMutations} = createNamespacedHelpers('setting');

    export default {
        name: 'SummerTimeSetting',
        mixins: [
            pagingMixin,
            uploadMixin
        ],
        computed: {
            ...mapState(['specialMappings']),
            action() {
                return `${base}api/gxbooking/SpecialPeriodMapping/import`
            }
        },
        props: {
            loading: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            ...mapActions({
                getSpecialMappings: 'getSpecialMappingsAction',
                downloadSpecialTimeTemplate: 'downloadSpecialTimeTemplateAction',
                exportSpecialTimeSettings: 'exportSpecialTimeSettingsAction',
            }),
            ...mapMutations(['saveSpecialMappings']),
            semesterFormatted(semester) {
                return (Semesters.find(s => s.value === semester) || {text: '未定義'}).text;
            },

            async refresh() {
                await this.getSpecialMappings();
            },

            async onUploadSuccess(res) {
                const {success,  messages} = res;
                if (success) {
                    this.$message({
                        type: 'success',
                        message: '匯入成功'
                    });
                    await this.getSpecialMappings();
                } else {
                    this.$message({
                        type: 'warning',
                        message: messages.join(',')
                    });
                }
            },
        },
        watch: {
            specialMappings(current) {
                this.pagedData = this.pageData(current, 1);
            }
        },

        async created() {
            await this.getSpecialMappings();
        }
    }
</script>

<style scoped>

</style>